<template>
  <div class="mod-login" v-if="!isModLoggedIn">
    <div class="mod-login__panel">
      <IdentityInput v-model="creds" :isMod="true" @submit="handleModLogin" />
    </div>
  </div>
  <div :class="`mod-view active-${activeView}`" v-else>
    <div class="mod-approve">
      <p
        :class="`mod-approve__buton ${activeView == 'chat' ? 'active' : ''} `"
        @click="updateActiveView('chat')"
      >
        CHAT
      </p>
      <p
        :class="
          `mod-approve__buton ${activeView == 'pending' ? 'active' : ''} `
        "
        @click="updateActiveView('pending')"
      >
        PENDING
      </p>
    </div>
    <div class="mod-chat-panel chat-view-default">
      <Chat theme="mod" messageType="accepted" isMod v-if="loaded" />
    </div>
    <div class="mod-chat-panel chat-view-pending">
      <Chat
        theme="admin"
        messageType="pending"
        isMod
        canApprove
        preventScroll
        v-if="loaded"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex"

import "@/components/Chat/themeMod.scss"
import Chat from "@/components/Chat/Chat.vue"
import IdentityInput from "@/components/IdentityInput"

export default {
  data: () => ({
    creds: {
      name: "",
      password: ""
    },
    activeView: "chat"
  }),

  components: {
    Chat,
    IdentityInput
  },

  mounted() {},

  methods: {
    ...mapActions(["doModLogin"]),

    handleModLogin() {
      this.doModLogin(this.creds).then(() => {
        let partyId = this.$route.query.party_id
        this.$store.dispatch("chatStore/init", partyId)
      })
    },
    updateActiveView(value) {
      this.activeView = value
    }
  },

  computed: {
    ...mapState({
      isModLoggedIn: state => state.isModLoggedIn,
      loaded: state => state.chatStore.loaded
    })
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";

.mod-approve {
  display: none;
}

.mod-login {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $bleach-pink;

  &__panel {
    position: relative;
    width: 400px;
    height: auto;
  }
}

.mod-view {
  background: $bleach-pink;
  height: 100vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.mod-chat-panel {
  height: 100%;
}

@media screen and (max-width: 720px) {
  .mod-view {
    flex-direction: column;
    justify-content: flex-start;
  }

  .mod-approve {
    display: flex;
    justify-content: space-around;
    width: 100%;
  }

  .mod-approve__buton {
    background-color: #afe2be;
    cursor: pointer;
    color: white;
    font-size: 16px;
    font-weight: 800;
    font-family: "Karla";
    padding: 15px 20px;
    min-width: 150px;
    text-align: center;
    width: 50%;

    &.active {
      background-color: #c6fdd5;
      color: #ebacc5;
      border-bottom: 4px solid #ebacc5;
    }
  }

  .mod-view.active-chat {
    .chat-view-default {
      display: block;
      height: calc(100% - 60px);
    }

    .chat-view-pending {
      display: none;
    }
  }

  .mod-view.active-pending {
    .chat-view-default {
      display: none;
    }

    .chat-view-pending {
      display: block;
      height: calc(100% - 60px);
      width: 100%;
    }
  }
}
</style>
